import styled from "@emotion/styled";

export const CalendarView = styled.div`
  .MuiTypography-root {
    font-size: 14px !important;
  }
`;
